import { Action } from '@ngrx/store';

// Get all venues
export const GET_ALL_VENUES = '[Entertainment Event] Get All Venues';
export const GET_ALL_VENUES_SUCCESS = '[Entertainment Event] Get All Venues Success';
export const GET_ALL_VENUES_FAIL = '[Entertainment Event] Get All Venues Fail';

export class GetAllVenues implements Action {
  readonly type = GET_ALL_VENUES;
  constructor(public payload: any) {}
}

export class GetAllVenuesSuccess implements Action {
  readonly type = GET_ALL_VENUES_SUCCESS;
  constructor(public payload: any) {}
}

export class GetAllVenuesFail implements Action {
  readonly type = GET_ALL_VENUES_FAIL;
  constructor(public payload: any) {}
}

// Get individual venue
export const GET_INDIVIDUAL_VENUE = '[Entertainment Event] Get Individual Venue';

export class GetIndividualVenue implements Action {
  readonly type = GET_INDIVIDUAL_VENUE;
  constructor(public payload: any) {}
}

export type EntertainmentEventVenuesAction = GetAllVenues | GetAllVenuesSuccess | GetAllVenuesFail | GetIndividualVenue;
